import { FC } from 'react';
import UserList from '../components/users/UserList';
import { WrapInLayout } from '../layouts';

const UsersPage: FC = () => (
  <WrapInLayout title="Users" layout="portal">
    <UserList />      
  </WrapInLayout>
);

export default UsersPage;
